// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7271":"css/admin-app.6651","8180":"css/app.6651"}[chunkId] + ".css";
};